import { CrossIcon, SearchIcon } from './CheckMark'

export function SearchField({
  value,
  onChange,
  placeholder,
  count,
  clearLabel,
  autoFocus,
  compact,
}: {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  count?: number | string
  clearLabel: string
  autoFocus?: boolean
  compact?: boolean
}) {
  return (
    <div
      className={`flex items-center gap-[9px] border border-hairline bg-field transition-[background-color,border-color,box-shadow] duration-row focus-within:border-accent focus-within:bg-field-focus focus-within:shadow-focus ${
        compact ? 'h-field rounded-nested px-[11px]' : 'h-field rounded-nested px-[13px]'
      }`}
    >
      <span className={value ? 'text-accent' : 'text-text-secondary'}>
        <SearchIcon />
      </span>
      <input
        type="search"
        value={value}
        autoFocus={autoFocus}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className={`min-w-0 flex-1 border-0 bg-transparent text-text outline-hidden placeholder:text-text-muted [&::-webkit-search-cancel-button]:hidden ${
          compact ? 'text-list' : 'text-body'
        }`}
      />
      {count !== undefined ? (
        <span className="tabular flex-none px-[6px] font-medium text-meta text-text-secondary">
          {count}
        </span>
      ) : null}
      {value ? (
        <button
          type="button"
          aria-label={clearLabel}
          onMouseDown={(event) => {
            event.preventDefault()
            onChange('')
          }}
          onClick={() => onChange('')}
          className="pressable flex h-6 w-6 flex-none items-center justify-center rounded-full bg-fill text-text-strong"
        >
          <CrossIcon />
        </button>
      ) : null}
    </div>
  )
}
